import React, { useState } from "react";

export default function NicknamePopup({ onContinue }) {
  const [nickname, setNickname] = useState("");

  const isValidNickname = nickname.trim().length >= 3;

  return (
    <>
      {/* BACKDROP */}
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" />

      {/* POPUP CONTAINER */}
      <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
        <div
          className="
            w-full max-w-md
            rounded-3xl
            border border-white/20
            bg-black/40
            backdrop-blur-xl
            shadow-2xl
            px-8 py-10
          "
        >
          {/* TITLE */}
          <h2 className="text-white text-2xl font-semibold text-center">
            Welcome!
          </h2>

          {/* SUBTITLE */}
          <p className="text-gray-300 text-center mt-2">
            Pick a nickname and start having fun.
          </p>

          {/* LABEL */}
          <div className="mt-10">
            <label className="block text-white text-sm mb-2">
              Nickname
            </label>

            {/* INPUT */}
            <input
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder=""
              className="
                w-full
                rounded-full
                bg-black/70
                border border-white/30
                px-5 py-3
                text-white
                focus:outline-none
                focus:border-red-500
                transition
              "
            />
          </div>

          {/* CONTINUE BUTTON */}
          <button
            disabled={!isValidNickname}
            onClick={() => onContinue(nickname)}
            className={`
              w-full mt-8 py-3 rounded-full text-white font-semibold
              transition-all duration-300
              ${
                isValidNickname
                  ? "bg-red-500 hover:scale-[1.02]"
                  : "bg-red-500 cursor-not-allowed"
              }
            `}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
}